// Auto generated file, do not manually modify!
// com.hotpads.satellite.web.api.web.renter.v1.lead.SatelliteWebRenterLeadHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import { SatelliteWebRenterLeadHandler_requestToApply } from '@zg-rentals/ts-satellite-client';

import type {
  SatelliteWebRenterLeadRequestToApplyRequestDto,
  SatelliteWebRenterLeadRequestToApplyResponseDto,
} from '@zg-rentals/ts-satellite-client';

export interface SatelliteWebRenterLeadHandler_requestToApply_Args {
  postData: SatelliteWebRenterLeadRequestToApplyRequestDto;
}

export type SatelliteWebRenterLeadHandler_requestToApply_Options = UseMutationOptions<
  SatelliteWebRenterLeadRequestToApplyResponseDto,
  unknown,
  SatelliteWebRenterLeadHandler_requestToApply_Args
>;

/**
 * Request to apply to a listing
 */
export const useSatelliteWebRenterLeadHandler_requestToApply = ({
  httpClient,
  ...options
}: Omit<SatelliteWebRenterLeadHandler_requestToApply_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: SatelliteWebRenterLeadHandler_requestToApply_Args) =>
      SatelliteWebRenterLeadHandler_requestToApply(args.postData, httpClient),
  });
};
